<div class="cc-panel" *ngIf="row">
  <section class="cc-card">
    <div class="cc-card__header">
      <span class="cc-card__title"><mat-icon>credit_card</mat-icon> Datos de la tarjeta</span>
      <app-status-pill [variant]="expiryVariant" [label]="expiryLabel"></app-status-pill>
    </div>

    <div class="cc-lines">
      <div class="cc-line">
        <span class="cc-line__label">Nombre</span>
        <span class="cc-line__value">{{ row.name || '—' }}</span>
      </div>
      <div class="cc-line">
        <span class="cc-line__label">Número</span>
        <span class="cc-line__value cc-line__value--mono">{{ maskedNumber || '—' }}</span>
      </div>
      <div class="cc-line">
        <span class="cc-line__label">Cuenta bancaria</span>
        <span class="cc-line__value">{{ row.accountAssociated || '—' }}</span>
      </div>
      <div class="cc-line">
        <span class="cc-line__label">Cuenta contable</span>
        <span class="cc-line__value">{{ row.accountNumber || '—' }}</span>
      </div>
    </div>

    <div class="cc-kpis" *ngIf="!loading && !error">
      <div class="cc-kpi">
        <span class="cc-kpi__label">Dispuesto {{ year }}</span>
        <span class="cc-kpi__value">{{ disposed | number:'1.2-2' }} €</span>
      </div>
      <div class="cc-kpi">
        <span class="cc-kpi__label">Liquidado {{ year }}</span>
        <span class="cc-kpi__value">{{ settled | number:'1.2-2' }} €</span>
      </div>
      <div class="cc-kpi cc-kpi--accent">
        <span class="cc-kpi__label">Dispuesto − liquidado</span>
        <span class="cc-kpi__value">{{ difference | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="cc-card__actions" *ngIf="row.accountNumber">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="ledger.emit()">
        <mat-icon>library_books</mat-icon> Mayor contable
      </button>
    </div>
  </section>

  <section class="cc-card">
    <div class="cc-card__header">
      <span class="cc-card__title"><mat-icon>swap_horiz</mat-icon> Movimientos del ejercicio {{ year }}</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando movimientos…"></app-loading-state>

    <div class="cc-empty cc-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar los movimientos de la tarjeta.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="cc-block" *ngFor="let block of blocks; trackBy: trackByType">
        <div class="cc-block__header">
          <span class="cc-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
          <span class="cc-block__side">
            <span class="cc-block__summary" *ngIf="block.count > 0" [title]="block.charges ? 'Comisiones e intereses ' + (block.charges | number:'1.2-2') + ' €' : ''">
              {{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong>
            </span>
            <button mat-stroked-button type="button" class="cf-btn cf-btn--primary cc-add" (click)="add(block)">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </span>
        </div>

        <div class="cc-moves" *ngIf="block.lines.length">
          <div class="cc-move" *ngFor="let line of block.lines; trackBy: trackByUid">
            <span class="cc-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
            <span class="cc-move__info">
              <span class="cc-move__concept" [title]="line.concept">{{ line.concept }}</span>
              <span class="cc-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
            </span>
            <span class="cc-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
            <span class="cc-move__actions">
              <button type="button" class="cc-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar movimiento">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" class="cc-icon-btn cc-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar movimiento">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" class="cc-more" *ngIf="block.count > maxLines" (click)="manage(block)">
            Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="cc-block__empty" *ngIf="!block.lines.length">Sin movimientos en el ejercicio</div>
      </div>
    </ng-container>
  </section>
</div>
